import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import Component from 'components/Settings/Customer/Startup'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

export default connect(mapStateToProps, null)(Component)
